function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.33 7.49L17.29.53a1.84 1.84 0 0 1 2.6 0c.73.72.72 1.9.01 2.61L12.05 11a1.84 1.84 0 0 1-1.37.54 1.88 1.88 0 0 1-2.02-.42L.7 3.16A1.87 1.87 0 0 1 .7.51a1.88 1.88 0 0 1 2.65 0l6.98 6.98z",
  fill: "#FFF"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 21,
    height: 12
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/dropdown.4891df14.svg";
export { SvgComponent as ReactComponent };